import React from 'react';
import { parseVideoUrl, backgroundEmbedUrl } from '@/lib/videoEmbed';

/**
 * Hero background video: an uploaded MP4/WebM plays in <video>; a YouTube or
 * Vimeo link plays as a muted, looping, control-free iframe scaled to cover
 * the hero like object-fit: cover. Returns null when the link can't play, so
 * the hero falls back to its image/gradient instead of going blank.
 */
export function HeroVideoBackground({ url, loop = true, muted = true }) {
  const video = parseVideoUrl(url);
  if (!video || video.kind === 'unknown') return null;

  if (video.kind === 'file') {
    return (
      <video
        src={video.url}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted={muted}
        loop={loop}
        playsInline
      />
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden" style={{ containerType: 'size' }}>
      <iframe
        src={backgroundEmbedUrl(video, { loop })}
        title="Background video"
        tabIndex={-1}
        aria-hidden="true"
        allow="autoplay; encrypted-media; picture-in-picture"
        frameBorder="0"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          // 16:9 player stretched to cover the hero (cq units = hero size)
          width: 'max(100cqw, 177.78cqh)',
          height: 'max(100cqh, 56.25cqw)',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          border: 0,
        }}
      />
    </div>
  );
}

export function canPlayAsBackground(url) {
  const video = parseVideoUrl(url);
  return !!video && video.kind !== 'unknown';
}

export default HeroVideoBackground;
